// Class: lime.graphics.RenderContext

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;

// Constructor

var RenderContext = function() {
}

// Meta

RenderContext.__name__ = "lime.graphics.RenderContext";
RenderContext.__isInterface__ = false;
RenderContext.prototype = {
	
};
RenderContext.prototype.__class__ = RenderContext.prototype.constructor = $hxClasses["lime.graphics.RenderContext"] = RenderContext;

// Init



// Statics




// Export

exports.default = RenderContext;